module.exports = __webpack_public_path__ + "static/media/SY.33febfd7.svg";